import React from "react";
import { HiOutlineBars3 } from "react-icons/hi2";
import { SidebarFooter } from "./SidebarFooter";
import { NavList } from "./NavList";
import { borderSub, btnHover, textPrimary, roundedBtn } from "./designTokens";

export function Sidebar({
  isCollapsed,
  setIsCollapsed,
  navItems,
  isActive,
  handleNavigation,
  user,
  handleLogout,
  menuTitle,
  t,
}) {
  return (
    <aside
      className={`hidden lg:flex flex-col shrink-0 h-full transition-[width] duration-300 ease-out border-r ${borderSub} min-w-[4.5rem] ${
        isCollapsed ? "w-[4.5rem]" : "w-[19.5rem] xl:w-[21rem]"
      } relative z-20`}
    >
      <div className="flex flex-col h-full py-6 px-3 gap-2 min-h-0 bg-white/10 dark:bg-gray-800/50 backdrop-blur-lg rounded-2xl shadow-xl border border-slate-200/50 dark:border-slate-600/50 m-2">
        <div
          className={`flex items-center gap-3 shrink-0 ${isCollapsed ? "justify-center" : "px-2"}`}
        >
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className={`flex items-center justify-center ${roundedBtn} text-white ${btnHover} transition-colors ${isCollapsed ? "w-10 h-10" : "w-9 h-9"}`}
            aria-label={isCollapsed ? "Ouvrir le menu" : "Réduire le menu"}
          >
            <HiOutlineBars3 className="w-5 h-5" />
          </button>
          {!isCollapsed && (
            <span
              className={`text-sm font-semibold text-white ${textPrimary} truncate`}
            >
              {menuTitle || "Menu"}
            </span>
          )}
        </div>

        <nav className="flex-1 overflow-y-auto py-2 space-y-0.5 min-h-0">
          <NavList
            items={navItems}
            isActive={isActive}
            onSelect={handleNavigation}
            iconOnly={isCollapsed}
          />
        </nav>

        <SidebarFooter
          isCollapsed={isCollapsed}
          user={user}
          handleLogout={handleLogout}
          t={t}
        />
      </div>
    </aside>
  );
}
